import React from 'react';

import { useIntl } from 'react-intl';

import { queryClient } from 'src/lib/react-query';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { toast } from 'src/hooks/useToast';
import { useCreateSubscriptionItem } from 'src/features/subscriptionItems/api/useCreateSubscriptionItem';
import { LIST_SUBSCRIPTION_ITEMS_RESOURCE } from 'src/features/subscriptionItems/api/useListSubscriptionItems';
import { subscriptionItemsMessages } from 'src/features/subscriptionItems/utils/messages';
import SubscriptionItemFormModal from 'src/features/subscriptionItems/components/forms/SubscriptionItemFormModal';
import { useParams } from 'react-router-dom';

interface CreateSubscriptionItemFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    children?: React.ReactNode;
}

function CreateSubscriptionItemFormModal<TData>({ className, semantics }: CreateSubscriptionItemFormModalProps<TData>) {
    const { formatMessage } = useIntl();
    const { subscriptionId = '' } = useParams();

    const { mutate, isPending } = useCreateSubscriptionItem({
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: [LIST_SUBSCRIPTION_ITEMS_RESOURCE] });
            toast({
                title: formatMessage(subscriptionItemsMessages.createSubscriptionItemSuccess),
                description: formatMessage(subscriptionItemsMessages.createSubscriptionItemSuccessDescription),
            });
        },
    });

    return (
        <SubscriptionItemFormModal
            className={className}
            mutate={(values, onSuccess, onError) => mutate({ ...values, subscriptionId }, { onSuccess, onError })}
            title={formatMessage(generalMessages.createEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(subscriptionItemsMessages.addSubscriptionItemSubtitle)}
        />
    );
}

export default CreateSubscriptionItemFormModal;
